import { combineReducers } from 'redux';
import configureStore from './CreateStore'
import rootSaga from '../sagas'
import { persistReducer, persistStore } from 'redux-persist';
import { createBrowserHistory as createHistory } from 'history';
import { connectRouter } from 'connected-react-router';
import { resettableReducer } from 'reduxsauce'
import storage from 'redux-persist/lib/storage'
import { seamlessImmutableReconciler, seamlessImmutableTransformCreator } from 'redux-persist-seamless-immutable';
import { reducer as UserAccountReducer } from './UserAccountRedux';
import { reducer as DisplayReducer } from './DisplayRedux';
import { reducer as AdLibraryReducer } from '../newSrc/features/adLibrary/redux/AdLibraryRedux';
import { reducer as ChatbotReducer } from '../components/features/ia_chatbot/redux/ChatbotRedux';
import { setVenueCatalog } from '../services/venueCategories';

const resettable = resettableReducer('RESET')
const history = createHistory();

const transformerConfig = {
  blacklistPerReducer: {
    chatbot: [
      'sendingMessage',
      'confirmingProposal',
      'resettingSession',
      'error',
      'messages',
      'currentProposal',
      'currentProposalId',
      'currentAction',
      'suggestReset',
      'sessionId',
      'autoOpenRequested',
    ],
    display: [
      'creatingPayment',
      'creatingQuote',
      'fetchingCampaign',
      'fetchingPayments',
      'deletingPayment',
      'errors',
      'checkingDisplaysByIds',
      'checkDisplaysByIdsResult',
      'clusterPolygonLoading',
      'clusterPolygonHadErrors',
      'creatingCampaign',
      'editingCampaign',
      'campaignAsyncOperation',
      'retryingCampaignAsyncOperation',
      'loadingPlanner',
      'loadingPlannerSkip',
    ],
    userAccount: [
      'fetching',
      'errors',
      'fetchingClients',
      'clientsError',
      'uploadingAvatar',
      'avatarError',
    ],
    library: [
      'loadingClients',
      'loadingAds',
      'loadingFolders',
      'uploading',
      'uploadProgress',
      'folderSubmitting',
      'folderError',
      'errors',
    ],
  },
};

const persistConfig = {
  key: 'primary',
  storage,
  stateReconciler: seamlessImmutableReconciler,
  transforms: [seamlessImmutableTransformCreator(transformerConfig)],
  timeout: null,
};

const appReducer = combineReducers({
  router: connectRouter(history),
  userAccount: resettable(UserAccountReducer),
  display: resettable(DisplayReducer),
  library: resettable(AdLibraryReducer),
  chatbot: ChatbotReducer,
})

const store = configureStore(
  persistReducer(persistConfig, appReducer),
  rootSaga,
  history,
);

// Venue labels resolve ids outside React: keep their taxonomy index in sync.
store.subscribe(() => setVenueCatalog(store.getState().display.venueTypes))

const persistor = persistStore(store)

export { store, history, persistor }
